(function () {
  'use strict';

  var SOURCE_LABELS = {
    'google-business': 'Google',
    google: 'Google',
    email: 'Judge.me',
    web: 'Judge.me',
    fulfillment: 'Judge.me',
    wizard: 'Judge.me',
    admin: 'Judge.me',
    'product-review-block': 'Judge.me',
    'all-reviews-page': 'Judge.me',
    'review-site': 'Judge.me',
    'air-reviews': 'Judge.me',
    aliexpress: 'Judge.me',
    judgeme: 'Judge.me'
  };

  function text(value) {
    return value == null ? '' : String(value).trim();
  }

  function ratingOf(review) {
    return Number(review.rating != null ? review.rating : review.r) || 0;
  }

  function normalizeReview(review) {
    var source = text(review.source != null ? review.source : review.s) || 'judgeme';

    return {
      id: text(review.id),
      rating: ratingOf(review),
      title: text(review.title != null ? review.title : review.t),
      body: text(review.body != null ? review.body : review.b),
      name: text(review.name != null ? review.name : review.n) || 'ATOM LED customer',
      source: source,
      sourceLabel: SOURCE_LABELS[source] || 'Judge.me',
      date: text(review.date != null ? review.date : review.d),
      productTitle: text(review.product_title != null ? review.product_title : review.pt),
      productHandle: text(review.product_handle != null ? review.product_handle : review.ph),
      verified: (review.verified != null ? review.verified : review.v) !== false
    };
  }

  function reviewTimestamp(review) {
    var raw = review.date || '';
    var timestamp = raw ? Date.parse(raw + (raw.indexOf('T') === -1 ? 'T00:00:00' : '')) : 0;
    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  function sortNewestFirst(a, b) {
    var dateDelta = reviewTimestamp(b) - reviewTimestamp(a);
    if (dateDelta) return dateDelta;
    return (Number(b.id) || 0) - (Number(a.id) || 0);
  }

  function formatDate(dateString) {
    if (!dateString) return '';
    var date = new Date(dateString + 'T00:00:00');
    if (Number.isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  function starStrip(rating, className) {
    var wrap = document.createElement('span');
    wrap.className = className || 'ar-card-stars';
    wrap.setAttribute('aria-label', rating.toFixed(0) + ' out of 5 stars');

    for (var index = 1; index <= 5; index += 1) {
      var star = document.createElement('span');
      star.textContent = '★';
      star.className = 'ar-star ' + (index <= Math.round(rating) ? 'ar-star--on' : 'ar-star--off');
      wrap.appendChild(star);
    }

    return wrap;
  }

  function createElement(tag, className, value) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (value != null) element.textContent = value;
    return element;
  }

  function productUrl(handle) {
    return handle ? '/products/' + encodeURIComponent(handle) : '';
  }

  function createBadge() {
    var verified = createElement('span', 'ar-badge ar-badge--verified');
    verified.title = 'Verified customer review';
    // Static SVG checkmark + "Verified" label — no user input, safe
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '13');
    svg.setAttribute('height', '13');
    svg.setAttribute('aria-hidden', 'true');
    var checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    checkPath.setAttribute('fill', 'currentColor');
    checkPath.setAttribute('d', 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z');
    svg.appendChild(checkPath);
    verified.appendChild(svg);
    verified.appendChild(createElement('span', null, 'Verified'));
    return verified;
  }

  function createProductRow(review) {
    if (!review.productTitle) return null;

    var product = review.productHandle ? document.createElement('a') : createElement('div');
    product.className = 'ar-card-product' + (review.productHandle ? '' : ' ar-card-product--no-link');
    if (review.productHandle) product.href = productUrl(review.productHandle);

    product.appendChild(createElement('span', 'ar-card-product__title', review.productTitle));

    if (review.productHandle) {
      var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      arrow.setAttribute('class', 'ar-card-product__arrow');
      arrow.setAttribute('viewBox', '0 0 24 24');
      arrow.setAttribute('width', '14');
      arrow.setAttribute('height', '14');
      arrow.setAttribute('aria-hidden', 'true');

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '2');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      path.setAttribute('d', 'M5 12h14M13 6l6 6-6 6');
      arrow.appendChild(path);
      product.appendChild(arrow);
    }

    return product;
  }

  function createReviewCard(review, reviewsUrl) {
    var article = createElement('article', 'ar-card');
    article.setAttribute('data-ar-card', '');
    article.setAttribute('data-ar-rating', String(review.rating));
    article.setAttribute('data-ar-source', review.sourceLabel);
    article.setAttribute('data-source', review.source);
    article.setAttribute('tabindex', '0');

    var top = createElement('header', 'ar-card-top');
    top.appendChild(createBadge());
    top.appendChild(starStrip(review.rating, 'ar-card-stars'));
    article.appendChild(top);

    var row = createElement('div', 'ar-card-row');
    var copy = createElement('div', 'ar-card-copy');
    if (review.title) {
      copy.appendChild(createElement('h3', 'ar-card-title', review.title));
    }
    if (review.body) {
      copy.appendChild(createElement('p', 'ar-card-body', review.body));
    }

    row.appendChild(copy);

    article.appendChild(row);

    var productRow = createProductRow(review);
    if (productRow) article.appendChild(productRow);

    var footer = createElement('footer', 'ar-card-foot');
    var avatar = createElement('span', 'ar-card-avatar', review.name.slice(0, 1).toUpperCase());
    footer.appendChild(avatar);

    var meta = createElement('div', 'ar-card-meta');
    meta.appendChild(createElement('span', 'ar-card-name', review.name));
    if (review.date) {
      var time = createElement('time', 'ar-card-date', formatDate(review.date));
      time.dateTime = review.date;
      meta.appendChild(time);
    }
    footer.appendChild(meta);

    var read = document.createElement('a');
    read.className = 'ar-card-read';
    read.href = reviewsUrl;
    read.textContent = 'Read review';
    footer.appendChild(read);

    article.appendChild(footer);
    return article;
  }

  function updateArrowState(root) {
    var track = root.querySelector('[data-ar-track]');
    var prev = root.querySelector('[data-ar-prev]');
    var next = root.querySelector('[data-ar-next]');
    if (!track || !prev || !next) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
  }

  function appendBatch(state) {
    var nextItems = state.reviews.slice(state.rendered, state.rendered + state.batchSize);
    var fragment = document.createDocumentFragment();
    nextItems.forEach(function (review) {
      fragment.appendChild(createReviewCard(review, state.reviewsUrl));
    });
    state.track.appendChild(fragment);
    state.rendered += nextItems.length;
    state.status.textContent = '';
    updateArrowState(state.root);
  }

  function cardAdvance(track) {
    var card = track.querySelector('.ar-card');
    if (!card) return track.clientWidth * 0.8;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '18') || 18;
    return card.getBoundingClientRect().width + gap;
  }

  function wireCarousel(state) {
    var prev = state.root.querySelector('[data-ar-prev]');
    var next = state.root.querySelector('[data-ar-next]');

    prev.addEventListener('click', function () {
      state.track.scrollBy({ left: -cardAdvance(state.track) * 2, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      if (state.rendered < state.reviews.length) appendBatch(state);
      state.track.scrollBy({ left: cardAdvance(state.track) * 2, behavior: 'smooth' });
    });

    state.track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var remaining = state.track.scrollWidth - state.track.clientWidth - state.track.scrollLeft;
        if (remaining < cardAdvance(state.track) * 3 && state.rendered < state.reviews.length) {
          appendBatch(state);
        }
        updateArrowState(state.root);
      });
    }, { passive: true });

    state.track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        next.click();
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prev.click();
      }
    });

    window.addEventListener('resize', function () {
      updateArrowState(state.root);
    }, { passive: true });
  }

  function renderAggregate(root, reviews, meta, reviewsUrl) {
    var average = Number(meta.avg || meta.average || 0);
    if (!average && reviews.length) {
      average = reviews.reduce(function (sum, review) {
        return sum + review.rating;
      }, 0) / reviews.length;
    }

    var averageText = average ? average.toFixed(2).replace(/0$/, '').replace(/\.0$/, '') : '5.0';

    var averageEl = root.querySelector('[data-ar-average]');
    var countEl = root.querySelector('[data-ar-count]');
    var viewAll = root.querySelector('[data-ar-viewall]');
    var summary = root.querySelector('[data-ar-summary]');

    if (averageEl) averageEl.textContent = averageText;
    if (countEl) countEl.textContent = '';
    if (viewAll) {
      viewAll.textContent = 'Read all reviews ';
      var arrow = createElement('span', null, '→');
      arrow.setAttribute('aria-hidden', 'true');
      viewAll.appendChild(arrow);
    }
    if (summary) {
      summary.href = reviewsUrl;
      summary.setAttribute('aria-label', 'Read all customer reviews');
    }
  }

  function normalizePayload(payload) {
    var reviews = Array.isArray(payload) ? payload : (payload.reviews || []);
    var meta = payload.meta || payload.aggregate || {};
    return {
      reviews: reviews.map(normalizeReview),
      meta: meta
    };
  }

  /**
   * Processes a parsed payload: normalizes, filters, sorts, renders cards
   * and wires the carousel. Shared by both the inline-feed path and the
   * fetch-fallback path.
   */
  function hydrateFromPayload(root, payload, minRating, batchSize, reviewsUrl) {
    var track = root.querySelector('[data-ar-track]');
    var status = root.querySelector('[data-ar-status]');
    var next = root.querySelector('[data-ar-next]');

    var normalized = normalizePayload(payload);
    var reviews = normalized.reviews
      .filter(function (review) {
        return review.rating >= minRating && (review.title || review.body);
      })
      .sort(sortNewestFirst);

    renderAggregate(root, reviews, normalized.meta, reviewsUrl);

    if (!reviews.length) {
      status.textContent = '';
      if (next) next.disabled = true;
      return;
    }

    track.replaceChildren();

    var state = {
      root: root,
      track: track,
      status: status,
      reviews: reviews,
      reviewsUrl: reviewsUrl,
      batchSize: batchSize,
      rendered: 0
    };

    appendBatch(state);
    wireCarousel(state);
  }

  /**
   * Try to read an inline JSON payload from a sibling
   * <script type="application/json" data-ar-inline-feed> element.
   * This is emitted by the Liquid snippet when the shop metafield
   * (atom_reviews.carousel) has fresh data from the cron refresh.
   *
   * Returns the parsed object, or null if not found / parse error.
   */
  function readInlineFeed() {
    var el = document.querySelector('[data-ar-inline-feed]');
    if (!el) return null;
    try {
      var payload = JSON.parse(el.textContent);
      if (payload && payload.reviews && payload.reviews.length > 0) {
        return payload;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function initRoot(root) {
    if (root.dataset.arReady === 'true') return;
    root.dataset.arReady = 'true';

    var feed = root.getAttribute('data-ar-feed');
    var minRating = Number(root.getAttribute('data-ar-min-rating')) || 3;
    var batchSize = Number(root.getAttribute('data-ar-batch-size')) || 18;
    var reviewsUrl = root.getAttribute('data-ar-reviews-url') || '/pages/reviews';
    var track = root.querySelector('[data-ar-track]');
    var status = root.querySelector('[data-ar-status]');

    if (!track || !status) return;

    // Priority 1: inline feed from metafield (no network request needed)
    var inlinePayload = readInlineFeed();
    if (inlinePayload) {
      hydrateFromPayload(root, inlinePayload, minRating, batchSize, reviewsUrl);
      return;
    }

    // Priority 2: fetch the static JSON asset file (fallback when no metafield)
    if (!feed) return;

    fetch(feed, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Review feed failed');
        return response.json();
      })
      .then(function (payload) {
        hydrateFromPayload(root, payload, minRating, batchSize, reviewsUrl);
      })
      .catch(function () {
        status.textContent = '';
        root.classList.add('ar-section--error');
        updateArrowState(root);
      });
  }

  function ready() {
    document.querySelectorAll('[data-ar-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-ar-root]').forEach(initRoot);
    }
  });
}());
